var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.loading,
          expression: "!loading",
        },
      ],
      staticClass: "teastodaycourselist-div",
    },
    [
      _vm.list.length == 0
        ? _c("van-empty", { attrs: { description: "暂无数据" } })
        : _c(
            "div",
            { staticClass: "list-content" },
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "div",
                { key: "listitem" + index, staticClass: "listitem-content" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "item-classname-content",
                      class:
                        item.calssTypeValue == 1
                          ? "item-classname-content-out"
                          : "item-classname-content-main",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "item-classname-logo",
                          class:
                            item.calssTypeValue == 1
                              ? "item-classname-logo-out"
                              : "item-classname-logo-main",
                        },
                        [_vm._v(_vm._s(item.calssTypeValue == 1 ? "外" : "主"))]
                      ),
                      _c("div", { staticClass: "item-classname-text" }, [
                        _vm._v(_vm._s(item.orgName || "")),
                      ]),
                    ]
                  ),
                  item.orgCourses && item.orgCourses.length > 0
                    ? _vm._l(item.orgCourses, function (tempItem, tempIndex) {
                        return _c(
                          "div",
                          { key: index + "courseitem" + tempIndex },
                          [
                            _c(
                              "DsfMobileTeasCell",
                              {
                                attrs: {
                                  cellShape: "none",
                                  border: true,
                                  title: tempItem.courseName || "",
                                },
                              },
                              [
                                _c("DsfMobileTeasCellItem", {
                                  attrs: {
                                    value: tempItem.teachingMode || "暂无",
                                    icon: "icon-icon-kcfl",
                                  },
                                }),
                                _c("DsfMobileTeasCellItem", {
                                  attrs: {
                                    value: tempItem.courseTime || "暂无",
                                    icon: "icon-shijian2",
                                  },
                                }),
                                _c("DsfMobileTeasCellItem", {
                                  attrs: {
                                    value: tempItem.teacher || "暂无",
                                    icon: "icon-icon-teacher",
                                  },
                                }),
                                _c("DsfMobileTeasCellItem", {
                                  attrs: {
                                    value: tempItem.classroom || "暂无",
                                    icon: "icon-location-hollow",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      })
                    : _vm._e(),
                ],
                2
              )
            }),
            0
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }